import { render, staticRenderFns } from "./ImportUpload.vue?vue&type=template&id=62d80a2f&scoped=true&"
import script from "./ImportUpload.vue?vue&type=script&lang=js&"
export * from "./ImportUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d80a2f",
  null
  
)

export default component.exports